import MetricBase from "models/metrics/MetricBase";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricRevenuePerclickWego extends MetricBase {
    constructor() {
        super({
            field: "metric_revenue_per_click",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.wego.revenuePerclick.chartName"),
            serieLabel: i18n.t("metrics.wego.revenuePerclick.serieLabel"),
            tooltip: i18n.t("metrics.wego.revenuePerclick.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricRevenuePerclickWego;
